export const USER_CONTENT_STATUS = {
  PASSIVE: 0,
  ACTIVE: 1,
  PENDING: 3,
  0: 'PASSIVE',
  1: 'ACTIVE',
  3: 'PENDING',
};
